import styled from 'styled-components'

export const PageContainer = styled.div`
  padding-bottom: 2rem;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;

  & > button {
    height: 100%;

    &:first-child {
      border-radius: 8px 0 0 8px;
    }

    &:last-child {
      border-radius: 0 8px 8px 0;
      border-left-width: 0px;
    }

    &:not(:first-child):not(:last-child) {
      border-radius: 0;
    }

    &:only-child {
      border-radius: 8px;
      border-width: 1px;
    }
  }
`

export const ButtonGroupContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  & > div > button {
    &:first-child {
      border-radius: 8px 0 0 8px;
    }

    &:last-child {
      border-radius: 0 8px 8px 0;
    }

    &:not(:first-child):not(:last-child) {
      border-radius: 0;
    }

    &:only-child {
      border-radius: 8px;
    }
  }
`

export const Button = styled.button`
  padding: 8px 16px;
  border: 2px solid ${(props) => props.color};
  border-radius: 8px;
  background-color: ${(props) => (props.isActive ? props.color : 'white')};
  filter: none;
  cursor: pointer;

  transition: background-color 200ms ease-in-out;

  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
  }

  &:not(:disabled) {
    &:hover {
      transition: background-color 50ms;
      background-color: ${(props) => props.color};
    }

    &:active {
      filter: brightness(0.9);
    }
  }
`

export const StyledTable = styled.table`
  position: relative;
  width: 100%;

  th,
  td {
    padding: 8px;
  }

  thead > tr {
    background-color: #e2e2e2;
  }

  tbody > tr {
    cursor: pointer;

    border-top: 1px solid #e2e2e2;
    border-bottom: 1px solid #e2e2e2;

    &:nth-child(odd) {
      background-color: #ffffff;
    }

    &:nth-child(even) {
      background-color: #f2f2f2;
    }

    &:hover {
      background-color: #e2e2e2;
    }

    &.locked {
      background-color: rgb(255, 192, 203);
    }

    td {
      &:nth-child(1) {
        width: 20%;
      }

      &:nth-child(2) {
        width: 20%;
      }

      &:nth-child(3) {
        width: 10%;
      }

      &:nth-child(4) {
        width: 10%;
      }

      &:nth-child(5) {
        width: 20%;
      }

      &:nth-child(6) {
        width: 10%;
      }
      &:nth-child(7) {
        width: 20%;
      }
    }
  }
`
